import { render } from "./BaseWidgetBody.vue?vue&type=template&id=6a266b88"
import script from "./BaseWidgetBody.vue?vue&type=script&lang=js"
export * from "./BaseWidgetBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__